module.exports = "\r\n  <h3 class=\"spectrum-header\">CIOview Drive Optimizer</h3>\r\n"